export const MAX_PAGE_SIZE = 100;

export default {
  MAX_PAGE_SIZE,
};
